export enum OrderState {
    TO_PROCESS,
    PROCESSING,
    PROCESSED,
    DELIVERED,
    FAILED
}